import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { AppUiModule } from '../../ui/app-ui.module';
import { NormativesRoutingModule } from './normatives-routing.module';
import { NormativesPageComponent } from './normatives-page/normatives-page.component';
import { NormativesComponent } from './normatives/normatives.component';
import { SpeedNormativesComponent } from './speed-normatives/speed-normatives.component';
import { NormativesService } from './normatives.service';
import { NormativeTableComponent } from './components/normative-table/normative-table.component';

@NgModule({
  declarations: [NormativesPageComponent, NormativesComponent, SpeedNormativesComponent, NormativeTableComponent],
  imports: [CommonModule, FormsModule, NgbDropdownModule, NgbPopoverModule, SharedModule, AppUiModule, NormativesRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [NormativesService],
})
export class NormativesModule {}
